/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js'; // Included with Angular CLI.
import { isCryptoRandomUUIDPolyfillNeeded, polyfillCryptoRandomUUID } from './polyfills.functions';

/***************************************************************************************************
 * APPLICATION IMPORTS
 */
(window as any).global = window;
global.Buffer = global.Buffer || require('buffer').Buffer;
(window as any).process = {
  env: {
    //DEBUG: undefined,
    //NODE_ENV: 'development'
  },
};
/**
 * 2020-09-28
 * Handles error TS2314: Generic type 'ModuleWithProviders<T>' requires 1 type argument(s).
 * The error originates from the openapi-generated files 'boards-api' and 'organisations-api'
 */
declare module '@angular/core' {
  interface ModuleWithProviders<T = any> {
    ngModule: Type<T>;
  }
}

/**
 * 2022-03-24
 * Handles error Error: Uncaught (in promise): ReferenceError: Can't find variable: process
 * The error originates from util.js, with this issue: https://github.com/browserify/node-util/issues/43
 */
(window as any).process = {
  env: { DEBUG: undefined },
};

/**
 * 2023-11-04
 * The randomUUID method in Crypto is not available on Safari versions older than 15.4, but by this date it's
 * used by one of our dependencies msal-angular (3.0.7) so we need a polyfill. This one works on Safari version
 * 14.1.2 and newer (older versions error because of other reasons - browserslist can help with those if we care).
 */
if (isCryptoRandomUUIDPolyfillNeeded(window)) {
  polyfillCryptoRandomUUID();
}

/**
 * 2025-05-09
 * Chrome / WebKit keeps spamming the console with
 *   “Unable to preventDefault inside passive event listener invocation”
 * when Angular CDK drag-and-drop (or Sentry Replay) calls
 * `event.preventDefault()` on a `mousemove` / `touchmove` event that the
 * browser has flagged as `passive`.
 *
 * Adding a *dummy* listener with `{ passive: false, capture: true }`
 * ensures there is already a non-passive handler in the chain, so the
 * warning is suppressed.
 *
 * Details: https://github.com/angular/components/issues/24979
 */
document.addEventListener('mousemove', () => {}, { passive: false, capture: true });
